import jwtDecode from 'jwt-decode';
// routes
import { PATH_AUTH } from '../routes/paths';
//
import axios from './axios';

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  
  try {
    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (error) {
    console.error('Error decoding token:', error);
    return false;
  }
};

// REMOVED: handleTokenExpired function
// We don't need this anymore because the axios interceptor 
// in AuthContext handles token refresh automatically

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    
  } else {
    localStorage.removeItem('accessToken');
    delete axios.defaults.headers.common.Authorization;
    console.log('🚪 Session cleared');
  }
};

// Tell the Flutter shell (when running inside the mobile WebView) that the
// session ended, so it clears its SharedPreferences token copy and
// unregisters the FCM device. Without this, a logged-out device keeps
// receiving the previous account's push notifications and a later
// Flutter-side refresh could resurrect the session.
const notifyFlutterLogout = () => {
  try {
    if (window.Flutter) {
      window.Flutter.postMessage(JSON.stringify({ type: 'logout' }));
      console.log('📤 Notified Flutter about logout');
    }
  } catch (e) {
    // Not in the WebView — nothing to do
  }
};

// Optional: Manual logout function if you need it elsewhere
const forceLogout = () => {
  notifyFlutterLogout();
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('lastLoginTime');
  localStorage.removeItem('lastBannerFetchTime');
  delete axios.defaults.headers.common.Authorization;
  window.location.href = PATH_AUTH.login;
};

export { isValidToken, setSession, forceLogout, notifyFlutterLogout };